import { render, staticRenderFns } from "./pricetable.vue?vue&type=template&id=5926a1c8&scoped=true&lang=pug&"
import script from "./pricetable.vue?vue&type=script&lang=js&"
export * from "./pricetable.vue?vue&type=script&lang=js&"
import style0 from "./pricetable.vue?vue&type=style&index=0&id=5926a1c8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5926a1c8",
  null
  
)

export default component.exports